module.exports = __webpack_public_path__ + "img/icon_primary_menu_metrc@2x.9dbcee65.png";